import { render, staticRenderFns } from "./AppSideEffectsWrapper.vue?vue&type=template&id=0148d728&scoped=true&"
import script from "./AppSideEffectsWrapper.vue?vue&type=script&lang=js&"
export * from "./AppSideEffectsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AppSideEffectsWrapper.vue?vue&type=style&index=0&id=0148d728&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0148d728",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCardText,VCardTitle,VTab,VTabItem,VTabs,VTabsItems})
